import { gql } from 'graphql-request';

export const DEVICE_MANAGEMENT_LOGGEEDIN_DEVICES_QUERY = gql`
  query {
    loggedInDevices {
      __typename
      deviceId
      appName
      osName
      platformName
      deviceName
      registrationCity
      registrationState
      registrationCountry
      loggedInTime
      loggedOutTime
    }
  }
`;

export const DEVICE_MANAGEMENT_USERLOGINAUDIT_QUERY = gql`
  query ($deviceId: String!) {
    userLoginAudit(deviceId: $deviceId) {
      __typename
      deviceId
      userIp
      userCity
      userState
      userCountry
      loggedInTime
      loggedOutTime
    }
  }
`;

export const DEVICE_MANAGEMENT_REMOVEDEVICE_QUERY = gql`
  query ($deviceIds: [String!]!) {
    removeDevice(deviceIds: $deviceIds) {
      __typename
      status
      message
    }
  }
`;
